import script from "./UmbracoFormSingleChoice.vue?vue&type=script&setup=true&lang=ts"
export * from "./UmbracoFormSingleChoice.vue?vue&type=script&setup=true&lang=ts"

import "./UmbracoFormSingleChoice.vue?vue&type=style&index=0&id=57201224&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57201224"]])

export default __exports__